/**
 * Mood and song-structure descriptors produced by the analysis worker (docs/03 "Sections and
 * mood"). All slow-moving (seconds), smoothed, hysteresis-gated.
 */

export type Section = 'unknown' | 'intro' | 'groove' | 'buildup' | 'drop' | 'breakdown';

export interface MoodState {
  /** 0..1 loudness relative to the recent range. */
  energy: number;
  /** 0..1 calm ↔ intense (energy, tempo, density, brightness). Reliable. */
  arousal: number;
  /** 0..1 dark ↔ bright (spectral brightness + harmonicity proxy). Weak; use as a gentle bias. */
  valence: number;
  /** 0..1 onsets per second, normalized. */
  density: number;
  section: Section;
  /** 0..1 progress through a build-up. */
  buildup: number;
  /** Graph time of the most recent detected drop (or -Infinity). */
  lastDropTime: number;
  /** Graph time a drop is expected (from file pre-analysis), or null. */
  nextDropTime: number | null;
  /** Index of the current section; increments on every boundary. */
  sectionIndex: number;
}

export function idleMood(): MoodState {
  return {
    energy: 0,
    arousal: 0,
    valence: 0.5,
    density: 0,
    section: 'unknown',
    buildup: 0,
    lastDropTime: -Infinity,
    nextDropTime: null,
    sectionIndex: 0,
  };
}

export type EnergyTag = 'low' | 'mid' | 'high';

export function energyBucket(arousal: number): EnergyTag {
  return arousal < 0.35 ? 'low' : arousal < 0.68 ? 'mid' : 'high';
}
